import { render, staticRenderFns } from "./Authenticator.component.vue?vue&type=template&id=025f22ec"
import script from "./Authenticator.component.vue?vue&type=script&lang=js"
export * from "./Authenticator.component.vue?vue&type=script&lang=js"
import style0 from "./Authenticator.component.vue?vue&type=style&index=0&id=025f22ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports